// import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useParams } from "react-router-dom";
import { useFetchGetByIdfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { useCheckPermissions } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import InspeccionFCorporativoPage from "./InspeccionFCorporativoPage";

export default function InspeccionFCorporativoContainer() {

  useCheckPermissions(PermissionsEnum.api_change_factibilidadcoorporativa);

  const { idfactibilidadcorporativa } = useParams();

  // const { data: dataProspecto, isLoading: isLoadingProspecto } = useGetProspectoByIdProspecto(idprospecto!);

  const { data: dataFactibilidadCorporativa, isLoading: isLoadingFactibilidadCorporativa } = useFetchGetByIdfactibilidadCorporativos(idfactibilidadcorporativa!)

  if (isLoadingFactibilidadCorporativa) return <LoaderComponent />

  if (!dataFactibilidadCorporativa) return null;

  return (
    <InspeccionFCorporativoPage
      title="Inspección de Factibilidad Corporativa"
      // dataProspecto={dataProspecto!}
      dataFactibilidadCorporativa={dataFactibilidadCorporativa?.data}
      dataPreventa={dataFactibilidadCorporativa?.data?.preventa_corporativa_data!}
      updateFactibilidad={true}
      showSaveButton={true}
    />
  );

}